import Button from '@rio-cloud/rio-uikit/Button';
import useDarkMode from '@rio-cloud/rio-uikit/hooks/useDarkMode';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import {
  ButtonContainer,
  Container,
  Content,
  PagerContainer,
  PagerNavigationContainer,
  StyledImage
} from "@/components/organism/GetStartedSection/GetStartedSection.styles";
import PageNavigation from "@/components/organism/PageNavigation/PageNavigation";
import {
  gaPush,
  GET_STARTED_SECTION_ACTIONS,
  GET_STARTED_SECTION_CATEGORY,
} from '@/configuration/setup/googleAnalytics';
import { EAppRoutes } from '@/routes/routes';
import { setCurrentPage } from '@/store/about/aboutSlice';
import { setCurrentLayout } from '@/store/layout/layoutSlice';

const texts = {
  description: 'getStartedPage.getStartedSection.description',
  learnMoreLabel: 'getStartedPage.getStartedSection.learnMore.label',
  titlePartOne: 'getStartedPage.getStartedSection.title.partOne',
  titlePartTwo: 'getStartedPage.getStartedSection.title.partTwo',
  startChatLabel: 'getStartedPage.common.startChat.label',
  nextLabel: 'getStartedPage.whatIsFleetAssistant.label',
};

const GetStartedSection = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const isDarkMode = useDarkMode();
  const navigate = useNavigate();

  const handleReadMore = () => dispatch(setCurrentPage('page2'));

  const handleStartConversation = () => {
    gaPush({
      category: GET_STARTED_SECTION_CATEGORY,
      action: GET_STARTED_SECTION_ACTIONS.CLICK_START_CHAT,
      label: 'User clicked start chat',
    });
    dispatch(setCurrentLayout('chat'));
    navigate(EAppRoutes.CHAT);
  };

  return (
      <div>
        <Container isDarkMode={isDarkMode}>
          <StyledImage
            src="assets/images/how-it-works.svg"
            alt={`${intl.formatMessage({ id: texts.titlePartOne })} ${intl.formatMessage({ id: texts.titlePartTwo })}`}
          />
          <Content>
            <h3 className="h3 text-uppercase">
              <FormattedMessage id={texts.titlePartOne} />
              <span className="h3 text-uppercase text-color-primary margin-left-5">
                <FormattedMessage id={texts.titlePartTwo} />
              </span>
            </h3>
            <p className="margin-bottom-20">
              <FormattedMessage id={texts.description} />
            </p>
            <ButtonContainer>
              <Button bsStyle={Button.PRIMARY} onClick={handleStartConversation}>
                <FormattedMessage id={texts.startChatLabel} />
              </Button>
            </ButtonContainer>
          </Content>
        </Container>
        <PagerContainer>
          <PagerNavigationContainer>
            <PageNavigation
                onNext={handleReadMore}
                nextLabel={texts.nextLabel}
            />
          </PagerNavigationContainer>
        </PagerContainer>
      </div>
  );
};

export default GetStartedSection;
